module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_school_red-cdbd9edfaadbbb3ef11665bfa4b5e794.svg";